import React from "react";
import { CtaButton } from "./CtaButton";
export function StickyOfferBar({
  visible
}: {
  visible: boolean;
}) {
  if (!visible) return null;
  return <aside className="sticky-offer" aria-label="Workshop kit offer" data-id="element-202" data-mp="2tyzckziaey7s"><div className="shell" data-id="element-203" data-mp="2p77ocvmlt4kt"><p data-id="element-204" data-mp="2p6g1c972of65"><strong data-id="element-205" data-mp="2p6fze3nii53i">New Manager Essentials</strong><span data-id="element-206" data-mp="2p5ec90t81s5f">10 workshops + 5 bonuses · $27 USD</span></p><CtaButton href="#offer-details" size="sm" data-id="element-207" data-mp="2k7l9khr4ng9w">Get the kit</CtaButton></div></aside>;
}